module.exports = __webpack_public_path__ + "img/1.df5742e0.png";